<template>
  <page-container @window-return="refresh">
    <search-bar :items="[
      { key: 'category_ids', label: 'Categories', type: 'categroup', show_simple: true },
      { key: 'query', label: 'Part Number', type: 'input', width: 400, show_simple: true, hide_advanced: true },
      { key: 'part_no_is_accurate', label: '精确', type: 'checkbox', show_simple: true, hide_advanced: true },
      { key: 'part_no', label: 'Part Number', type: 'multi', width: 260 },
      { key: 'description', label: 'Description', type: 'multi', width: 260 },
      { key: 'brand', label: 'Brand', type: 'multi', width: 160 },
      { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'oper_id', label: 'Input', type: 'select', state: 'sales', option_value: 'id', option_label: 'realname', width: 120 },
      { key: 'oper_time', label: 'Time', type: 'timerange' },
      { key: 'class_id', label: 'Class', type: 'select', state: 'class', option_value: 'id', option_label: 'name', width: 260 },
      { key: 'company', label: 'Company', type: 'multi', width: 260 }
    ]" @search="doSearch"/>

    <div class="card">
      <div flex>
        <div>
          <el-radio-group v-model="sqlcode">
            <el-radio-button label="record_offer">Quotation</el-radio-button>
            <el-radio-button label="record_require">Require</el-radio-button>
          </el-radio-group>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>

      <cate-table :columns="columns"
      :data="list"
      :loading="loading"
      show-detail
      @detail-click="$open(`/product/${arguments[0]}/details`)"
      @part-click="partClick(arguments[0])"
      style="margin:10px 0;" />

      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
  </page-container>
</template>

<script>
import TopNav from '@/components/TopNav'
import ListFunc from '@/mixins/ListFunc'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  components: {
    TopNav
  },
  data () {
    return {
      sqlcode: 'record_offer',
      defaultOperTime: [moment().subtract(3, 'days'), moment().endOf('day')]
    }
  },
  computed: {
    columns () {
      if (this.sqlcode === 'record_offer') {
        return [
          { key: 'oper_time', title: 'Input Time' },
          { key: 'company_name', title: 'Company' },
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_c_qty', title: 'Qty' },
          { key: 'display_c_price', title: 'Price' },
          { key: 'c_remark', title: 'Remark' },
          { key: 'sales_name', title: 'Sales' }
        ]
      } else {
        return [
          { key: 'oper_time', title: 'Input Time' },
          { key: 'company_name', title: 'Company' },
          { key: 'part_no', title: 'Part Number' },
          { key: 'description', title: 'Description' },
          { key: 'brand', title: 'Brand' },
          { key: 'display_qty', title: 'Qty' },
          { key: 'display_price', title: 'Price' },
          { key: 'remark', title: 'Remark' },
          { key: 'sales_name', title: 'Sales' }
        ]
      }
    }
  },
  watch: {
    sqlcode () {
      this.refresh()
    }
  },
  methods: {
    doSearch (params) {
      if (this.$store.state.user.role_id >= 3) {
        params.sales_id = this.$store.state.user.id
      }
      this.search(params)
    },
    partClick (id) {
      if (this.sqlcode === 'record_offer') {
        this.$open(`/product/${id}/offer`)
      } else {
        this.$open(`/product/${id}/require`)
      }
    }
  }
}
</script>